/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLayoutFooter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M22 2v20H2V2zm-2 14H4v4h16zm0-12H4v10h16z" fill="currentcolor" fillRule="evenodd" />
  </Icon>
);
export { SvgLayoutFooter as LayoutFooter };
